import { Bot, FileText, Pencil, Upload } from 'lucide-react'
import {
  VAULT_CATEGORY_LABELS,
  VAULT_SOURCE_LABELS,
  VAULT_STATUS_LABELS,
} from '@/lib/vault-document.constants'

const CATEGORY_TONES: Record<string, string> = {
  POLICY: 'bg-status-blue-bg text-status-blue-strong',
  PROCEDURE: 'bg-primary-subtle text-cobalt-strong',
  TEMPLATE: 'bg-status-purple-bg text-status-purple-strong',
  RECORD: 'bg-status-green-bg text-status-green-strong',
  TRAINING: 'bg-status-orange-bg text-status-orange-strong',
  CERTIFICATE: 'bg-status-green-bg text-status-green-strong',
  REFERENCE: 'bg-muted text-text-subtle',
  OTHER: 'bg-muted text-text-subtle',
}

export function VaultDocumentCategoryBadge({ category }: { category: string }) {
  return (
    <span
      className={`inline-flex min-h-5 items-center rounded-full px-2 text-[11px] font-medium ${CATEGORY_TONES[category] ?? CATEGORY_TONES.OTHER}`}
    >
      {VAULT_CATEGORY_LABELS[category] ?? category}
    </span>
  )
}

export function VaultDocumentSourceIcon({
  sourceType,
}: {
  sourceType: string
}) {
  const className = 'size-3.5 text-text-subtle'
  const icon =
    sourceType === 'AGENT_GENERATED' ? (
      <Bot className='text-cobalt-strong size-3.5' />
    ) : sourceType === 'MANUAL' ? (
      <Pencil className={className} />
    ) : sourceType === 'UPLOADED' ? (
      <Upload className={className} />
    ) : (
      <FileText className={className} />
    )

  return (
    <span
      className='inline-flex items-center'
      title={VAULT_SOURCE_LABELS[sourceType] ?? sourceType}
      aria-label={VAULT_SOURCE_LABELS[sourceType] ?? sourceType}
    >
      {icon}
    </span>
  )
}

export function VaultDocumentStatusBadge({ status }: { status: string }) {
  const className =
    status === 'ARCHIVED'
      ? 'border-border bg-muted text-text-subtle'
      : 'border-status-green/30 bg-status-green-bg text-status-green-strong'

  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-medium ${className}`}
    >
      {VAULT_STATUS_LABELS[status] ?? status}
    </span>
  )
}
